import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

interface SearchState {
  history: string[];
  saveSearch: (query: string) => void;
  removeSearch: (query: string) => void;
  clearHistory: () => void;
}

const MAX_HISTORY_ITEMS = 5;

export const useSearchStore = create<SearchState>()(
  persist(
    (set) => ({
      history: [],
      saveSearch: (query: string) => {
        const trimmedQuery = query.trim();
        if (!trimmedQuery) return;

        set((state) => {
          const filteredHistory = state.history.filter((item) => item !== trimmedQuery);
          const newHistory = [trimmedQuery, ...filteredHistory].slice(0, MAX_HISTORY_ITEMS);
          return { history: newHistory };
        });
      },
      removeSearch: (query: string) => {
        set((state) => ({
          history: state.history.filter((item) => item !== query),
        }));
      },
      clearHistory: () => set({ history: [] }),
    }),
    {
      name: "movie_search_history",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
